var map = {
	"./account-details.svg": "dd73",
	"./giftcards.svg": "4f12",
	"./help.svg": "9510",
	"./impact.svg": "2245",
	"./invite.svg": "305f",
	"./logout.svg": "639d",
	"./mobile/campaigns-selected.svg": "d258",
	"./mobile/campaigns.svg": "0c70",
	"./mobile/dashboard-selected.svg": "f22e",
	"./mobile/dashboard.svg": "9365",
	"./mobile/impact-selected.svg": "291c",
	"./mobile/impact.svg": "43fa",
	"./mobile/loans-selected.svg": "26d6",
	"./mobile/loans.svg": "757c",
	"./mobile/profile-selected.svg": "b8cd",
	"./mobile/profile.svg": "6bc9",
	"./mobile/projects-selected.svg": "58a3",
	"./mobile/projects.svg": "243d",
	"./mobile/settings-nav-selected.svg": "55d6",
	"./mobile/settings-nav.svg": "456a",
	"./mobile/settings.svg": "32ec",
	"./redeem-code.svg": "60d8",
	"./settings.svg": "a972"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af37";